import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setResidenceOptions } from '../store/options.actions'

export function* getResidenceOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getResidenceOptions,
    ])
    const { entity } = response
    yield put(setResidenceOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getResidenceOptions() error: ${e}`))
  }
}

export function* getResidenceOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getResidenceOptions)
}
